<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="this.videoInfo.vod_name" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="movie-video">
      <video id="my-video" class="video-js"></video>
    </div>
    <div class="movie-content">
      <div class="movie-descript">
        <p>{{ this.videoInfo.vod_name }}</p>
        <span>{{ this.videoInfo.count }}{{ $t("video.num_play") }}</span>
      </div>

      <div class="movie-body">
        <div class="movie-title">
          <div>
            <span>{{ $t("index.recmonmand") }}</span>
          </div>
        </div>
      </div>
      <div  class="hotlist">
        <div  v-for="(v,key) in moreVideoInfo" :key="key" @click="toPlayVideo(v.id)">
          <img
            
            :src="v.vod_pic"
          />
          <div >
            <span >{{ v.vod_name }}</span
            ><span >{{$t("video.play")}}:{{ v.count }}</span>
          </div>
        </div>
     
      </div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  data() {
    return {
      nowPlayVideoUrl: "",
      cover: "",
      userInfo: [],
      videoInfo: {},
      moreVideoInfo: {},
      player: null,
      is_play: false,
      times: null,
      is_see: 0,
      adSkipSeconds: 0,
      adSkipApplied: false,
    };
  },
  methods: {
    back() {
      this.$router.push({ path: "/Video" });
    },
    getVideoInfo() {
      this.$http({
        method: "get",
        data: { id: this.$route.query.id },
        url: "video_get_info",
      }).then((res) => {
        this.videoInfo = res.data;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.cover = this.videoInfo.vod_pic;
        let videos = document.getElementById("my-video");
     
        videos.poster = this.cover;
        this.getVideo();
      });
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "?id=" + id });
        location.reload();
      }
    },
    getMoreVideoItem() {
      this.$http({
        method: "get",
        url: "video_get_more_item",
      }).then((res) => {
        this.moreVideoInfo = res.data;
      });
    },
    getVideo() {
      // this.player = videojs("my-video",  {
      //   height:"200px",
      //   preload: "auto", // 预加载
      //   controls: true,  // 显示播放的控件
      //   multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
      // });
      this.player.src([
        {
          src: this.nowPlayVideoUrl,
          type: "application/x-mpegURL", // 告诉videojs,这是一个hls流
        },
      ]);
      this.player.poster(this.cover);
      this.prepareAdSkip();
    },
    parseAdSkipSeconds(m3u8Text) {
      const lines = m3u8Text.split(/\r?\n/).map((line) => line.trim());
      let sum = 0;
      let sawExtInfBeforeDiscontinuity = false;
      for (const line of lines) {
        if (!line) continue;
        if (line.startsWith("#EXT-X-DISCONTINUITY")) {
          return sawExtInfBeforeDiscontinuity ? sum : 0;
        }
        if (line.startsWith("#EXTINF:")) {
          const match = line.match(/^#EXTINF:([0-9.]+)/);
          if (match && match[1]) {
            const d = parseFloat(match[1]);
            if (!Number.isNaN(d) && d > 0) {
              sum += d;
              sawExtInfBeforeDiscontinuity = true;
            }
          }
        }
      }
      return 0;
    },
    resolveM3u8Url(baseUrl, relativeUrl) {
      try {
        return new URL(relativeUrl, baseUrl).href;
      } catch (e) {
        return relativeUrl;
      }
    },
    extractFirstMediaPlaylistUrl(masterM3u8Text, masterUrl) {
      const lines = masterM3u8Text.split(/\r?\n/).map((line) => line.trim());
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        if (line.startsWith("#EXT-X-STREAM-INF")) {
          const nextLine = (lines[i + 1] || "").trim();
          if (nextLine && !nextLine.startsWith("#")) {
            return this.resolveM3u8Url(masterUrl, nextLine);
          }
        }
      }
      return "";
    },
    tryApplyAdSkip() {
      if (!this.player || this.adSkipApplied || this.adSkipSeconds <= 0) return;
      const target = this.adSkipSeconds + 0.1;
      const duration = this.player.duration();
      if (Number.isFinite(duration) && duration > 0 && target >= duration) return;
      try {
        this.player.currentTime(target);
        this.adSkipApplied = true;
      } catch (e) {
        // 等下一次可 seek 时再尝试
      }
    },
    async prepareAdSkip() {
      this.adSkipSeconds = 0;
      this.adSkipApplied = false;
      if (!this.nowPlayVideoUrl) return;
      try {
        const response = await fetch(this.nowPlayVideoUrl, { method: "GET" });
        if (!response.ok) return;
        const m3u8Text = await response.text();
        this.adSkipSeconds = this.parseAdSkipSeconds(m3u8Text);

        // 如果是主清单（无 EXTINF），继续解析第一条子清单
        if (this.adSkipSeconds <= 0) {
          const mediaPlaylistUrl = this.extractFirstMediaPlaylistUrl(
            m3u8Text,
            this.nowPlayVideoUrl
          );
          if (mediaPlaylistUrl) {
            const mediaResp = await fetch(mediaPlaylistUrl, { method: "GET" });
            if (mediaResp.ok) {
              const mediaText = await mediaResp.text();
              this.adSkipSeconds = this.parseAdSkipSeconds(mediaText);
            }
          }
        }

        if (this.adSkipSeconds > 0 && this.player) {
          // 多时机兜底，避免错过单次事件导致未跳过
          this.player.on("loadedmetadata", () => this.tryApplyAdSkip());
          this.player.on("canplay", () => this.tryApplyAdSkip());
          this.player.on("play", () => this.tryApplyAdSkip());
          this.player.on("timeupdate", () => this.tryApplyAdSkip());
          this.tryApplyAdSkip();
        }
      } catch (e) {
        this.adSkipSeconds = 0;
      }
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.is_see = this.userInfo.is_see;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear();
            this.$router.push({ path: "/Login" });
          } else {
            if (this.$store.getters.getBaseInfo.isplay == 1) {
              this.getVideoInfo();
              this.getMoreVideoItem();
              // if(this.userInfo.money <= "0.00"){
              //   this.$toast(this.$t("video.buy"));
              //   this.$router.push({path:'/Home'})
              // }
            } else {
              this.getVideoInfo();
              this.getMoreVideoItem();
            }
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  mounted() {
    const _this = this;
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
     
        this.player = videojs(
          "my-video",
          {
            height: "200px",
            preload: "auto", // 预加载
            controls: true, // 显示播放的控件
            multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
          },
          function () {
            this.on("play", () => {
              _this.is_play = true;
            });
          }
        );
      
      this.getUserInfo();
      this.times = setInterval(() => {
        if (this.is_play && this.is_see == 0) {
          const ct = Math.round(this.player.currentTime());
          if (ct >= 180) {
            this.player.pause();
            this.$toast(this.$t("video.buy"));
            return;
          }
        }
      }, 1000 * 2);
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
    if (this.is_play) {
      this.is_play = false;
    }
    clearInterval(this.times);
  },
};
</script>

<style scoped>
.video-js {
  width: 100%;
  /*height: 420px;*/
  font-size: 24px;
}
.movie-content {
  flex: 1;
  overflow-y: auto;
}
.movie-content .movie-descript {
  width: 100%;
  /* height: 140px; */
  /* background-color: #fff; */
  color: #f3c7a2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 15px;
}
.movie-content .movie-descript p {
  font-size: 30px;
  font-weight: 700;
  color: #f3c7a2;
}
.movie-content .movie-descript span {
  color: rgb(170, 45, 220);
  font-size: 0.8rem;
  background: rgb(242, 242, 245);
  padding: 10px;
  border-radius: 16px;
}
.movie-content .movie-body {
  width: calc(100% - 20px);
  margin: 0 auto;
}
::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}
.movie-content .movie-body .movie-title {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
}
.movie-content .movie-body .movie-title > div:first-child {
  width: 410px;
}
.movie-content .movie-body .movie-title > div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 30px;
  font-weight: 700;
  color: #f3c7a2;
}
.movie-content .movie-body .movie-title > div:first-child span:before {
  content: "";
  display: block;
  width: 8px;
  height: 30px;
  background-color: #7e5678;
  border-radius: 25px;
  margin-right: 10px;
}

abbr,
address,
article,
aside,
audio,
b,
blockquote,
body,
canvas,
caption,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
p,
pre,
q,
samp,
section,
small,
span,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  box-sizing: border-box;
}

.vjs-big-play-button .vjs-icon-placeholder {
  font-size: 1.63em !important;
}
.hotlist{
  display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.hotlist div{
  position: relative;
    width: calc(50% - 10px);
    border-radius: 16px;
    overflow: hidden;
    margin-bottom: 20px;
}
.hotlist div img{
  width: 100%;
  height: 27vw;
}
.hotlist div div{
  position: absolute;
    bottom: 20px;
    width: 100%;
    left: 0;
    background: rgba(0, 0, 0, .4);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 3vw;
    height: 8vw;
    border-radius: 16px;
}
.hotlist div div span{
  width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    padding-left: 20px;
}
</style>
